// Timeline "Est. start" can be a week range from signing (the original
// dropdown) OR a specific calendar date, e.g. a job booked for Feb 1.
//
// The date lives in its own per-estimate key beside the weeks key, so old
// estimates and old sent proposals (no date key / no snapshot field) keep
// printing their week range exactly as before. Empty / absent = weeks mode.

export const startDateKey = (estimateName: string) =>
  `du_timeline_start_date::${estimateName}`;

/** Select value used for the "Specific date…" choice (weeks are all >= 1). */
export const SPECIFIC_DATE_OPTION = 0;

/** True only for a real calendar date in YYYY-MM-DD form. */
export function isStartDate(v: unknown): v is string {
  if (typeof v !== "string") return false;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
  if (!m) return false;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return (
    d.getFullYear() === Number(m[1]) &&
    d.getMonth() === Number(m[2]) - 1 &&
    d.getDate() === Number(m[3])
  );
}

export function readStartDate(estimateName: string): string {
  try {
    const v = localStorage.getItem(startDateKey(estimateName));
    return isStartDate(v) ? v : "";
  } catch {
    return "";
  }
}

export function writeStartDate(estimateName: string, value: string) {
  try {
    if (isStartDate(value)) localStorage.setItem(startDateKey(estimateName), value);
    else localStorage.removeItem(startDateKey(estimateName));
  } catch {}
}

/** "2027-02-01" → "February 1, 2027". Parsed as a LOCAL date — new Date(iso)
 *  would read it as UTC midnight and print Jan 31 in US time zones. */
export function formatStartDate(iso: string): string {
  if (!isStartDate(iso)) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

/** Starting value when "Specific date…" is picked: today + the current weeks. */
export function defaultStartDate(weeks: number, now = new Date()): string {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + weeks * 7);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
